import { useState } from 'react';
import MmlButtons from './MmlButtons.js';
import MmlOverlay from './MmlOverlay.js';


export default function Mml({ onSave }) {
    const [ active, setActive ] = useState(false);

    return (
        <>
            <MmlButtons setOverlayActive={setActive} onSave={onSave} />
            {active && <MmlOverlay setActive={setActive} />}
        </>
    )
}